import styles from './IconArrowUpAndDown.module.scss';

export const IconArrowUpAndDown = () => (
  <svg
    className={styles.svg}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={styles.path}
      d="M5.42332 10.8362H18.1698C18.3327 10.8362 18.4806 10.743 18.5511 10.5964C18.6218 10.4502 18.6021 10.276 18.501 10.1491L12.1275 2.15934C12.0471 2.05862 11.9254 2 11.7968 2C11.6681 2 11.5462 2.05862 11.466 2.15934L5.09236 10.1491C4.991 10.2762 4.97132 10.4502 5.042 10.5964C5.11246 10.743 5.26038 10.8362 5.42332 10.8362Z"
    />
    <path
      className={styles.path}
      d="M18.1696 13.1638H5.42332C5.26059 13.1638 5.11246 13.2567 5.042 13.4036C4.97132 13.5498 4.991 13.7239 5.09236 13.8507L11.4658 21.8406C11.5462 21.9414 11.6679 22 11.7966 22C11.9252 22 12.0471 21.9414 12.1273 21.8406L18.5003 13.8507C18.6017 13.7235 18.6212 13.5498 18.5505 13.4036C18.4804 13.2567 18.3325 13.1638 18.1696 13.1638Z"
    />
  </svg>
);
